import defaultTheme from './themes/default.ts';

export const themes = {
    default: defaultTheme,
};
